import { UpdateUserMutation } from "src/api/User";
import { BorderButton } from "src/components/buttons/BorderButton";
import EnabledOfferingItem from "src/components/items/EnabledOfferingItem";
import { AddContactModal } from "src/components/modals/AddContactModal";
import { ConfirmModal } from "src/components/modals/ConfirmModal";
import { SettingModel } from "src/models/SettingModel";
import UserModel from "src/models/UserModel";
import { apiClient } from "src/stores/Api";
import { formatPhoneNumber } from "src/utils/formatPhone";
import message from "src/utils/message";
import { modals } from "src/utils/modals";
import { SettingType, updateUserVariables } from "types/code-generator";

interface Props {
  user: UserModel;
  onUserProfileUpdate?: () => void;
}

export default function AccountOwnerNotifications(props: Props) {
  function removeEmail(setting: SettingModel) {
    modals.show(ConfirmModal, {
      title: "Delete Additional Contact?",
      body: `Are you sure you’d like to delete ${setting.value}?`,
      buttonText: "Yes, Delete",
      handleOk() {
        updateUser(setting, true);
      },
    });
  }

  function removePhone(setting: SettingModel) {
    modals.show(ConfirmModal, {
      title: "Delete Additional Contact?",
      body: `Are you sure you’d like to delete ${setting.value}?`,
      buttonText: "Yes, Delete",
      handleOk() {
        updateUser(setting, true);
      },
    });
  }

  function addSecondaryEmail(setting?: SettingModel) {
    modals.show(AddContactModal, {
      type: SettingType.SecondaryContactEmail,
      user: props.user,
      setting,
      onSubmit: updateUser,
    });
  }

  function addSecondaryPhone(setting?: SettingModel) {
    modals.show(AddContactModal, {
      type: SettingType.SecondaryContactPhone,
      user: props.user,
      setting,
      onSubmit: updateUser,
    });
  }

  async function updateUser(setting: SettingModel, remove: boolean = false) {
    console.log("setting", setting);

    const variables: updateUserVariables = {
      data: {
        settings: {
          update: [],
          create: [],
          delete: [],
        },
      },
      where: {
        id: props.user.id,
      },
    };

    if (setting.type === SettingType.SecondaryContactEmail) {
      if (setting.id) {
        variables.data.settings.update.push({
          data: {
            value: setting.value.toLowerCase(),
          },
          where: {
            id: setting.id,
          },
        });
      } else {
        variables.data.settings.create.push({
          value: setting.value,
          type: SettingType.SecondaryContactEmail,
        });
      }
    } else if (setting.type === SettingType.SecondaryContactPhone) {
      if (setting.id) {
        variables.data.settings.update.push({
          data: {
            value: formatPhoneNumber(setting.value),
          },
          where: {
            id: setting.id,
          },
        });
      } else {
        variables.data.settings.create.push({
          value: formatPhoneNumber(setting.value),
          type: SettingType.SecondaryContactPhone,
        });
      }
    }

    if (remove) {
      variables.data.settings.delete.push({
        id: setting.id,
      });
    }

    const result = await apiClient(UpdateUserMutation, {
      variables,
    });

    if (result.updateUser) {
      message.success("Changes saved");

      if (props.onUserProfileUpdate) {
        props.onUserProfileUpdate();
      }
    }
  }

  const secondaryEmails = props.user.secondaryContactEmails.map((c) => {
    return (
      <EnabledOfferingItem
        key={c.id}
        removeItem={() => removeEmail(c)}
        onClick={() => addSecondaryEmail(c)}
        className="cursor-pointer"
      >
        <div className="flex items-center gap-2">
          <div>
            <i className="far fa-envelope text-organization" />
          </div>
          <div>{c.value}</div>
        </div>
      </EnabledOfferingItem>
    );
  });

  const secondaryPhones = props.user.secondaryContactPhones.map((p) => {
    return (
      <EnabledOfferingItem
        key={p.id}
        removeItem={() => removePhone(p)}
        onClick={() => addSecondaryPhone(p)}
        className="cursor-pointer"
      >
        <div className="flex items-center gap-2">
          <div>
            <i className="far fa-phone text-organization" />
          </div>
          <div>{p.value}</div>
        </div>
      </EnabledOfferingItem>
    );
  });

  return (
    <section>
      <div className="mb-2">{secondaryEmails}</div>
      <div className="mb-2">{secondaryPhones}</div>

      <div className="flex gap-2 sm:flex-col">
        <BorderButton dashed onClick={() => addSecondaryEmail()}>
          <i className="far fa-plus text-organization" /> Add Additional Email
        </BorderButton>

        <BorderButton dashed onClick={() => addSecondaryPhone()}>
          <i className="far fa-plus text-organization" /> Add Additional Phone
        </BorderButton>
      </div>
    </section>
  );
}
